import {LoadingButton} from '@mui/lab';
import {Box} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {saveFile} from '../../utils/file';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import ExportFieldForm from '../common/ExportFieldForm';
import ModalFixed from '../common/ModalFixed';
import SnackbarMessages from '../common/SnackbarMessages';
import {
  BeltMonitoringReportData,
  BeltMonitoringReportDataExportFields,
} from '../dashboard-panels/ConnectView/BeltMonitoringReport';

interface Props {
  value?: BeltMonitoringReportData | BeltMonitoringReportDataExportFields;
}

const BeltExportExcel = ({value}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);

  const [isOpened, setIsOpened] = useState(false);

  const checkFields = () => {
    setIsOpened(true);
  };

  const fetchData = async (fields: string[]) => {
    setIsOpened(false);
    setIsFetching(true);
    try {
      const params = {
        ...value?.params,
        export: 'excel',
        fields,
      };
      const resp = await API.get(`${apiBaseUrl}/belt`, {
        params,
        responseType: 'blob',
      });
      saveFile(resp.data, `belt.xlsx`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_b045ff74");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          loading={isFetching}
          onClick={() => checkFields()}
        >
          Export to Excel
        </LoadingButton>
      </Box>
      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <ExportFieldForm
                exportFields={value?.exportFields}
                loading={isFetching}
                onChange={fetchData}
                close={() => setIsOpened(false)}
              />
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default BeltExportExcel;
